const VALIDATION_RESULT_SUFFIX = /^(isValid|message|severity)_\d+$/;

export default (state, {instanceKey, field}) => {
  const touchedKey = `${instanceKey}_touched`;
  const touched = state[touchedKey] || [];
  const remaining = touched.filter(touchedField => touchedField !== field);

  const prefix = `${instanceKey}_validation_${field}_`;
  const validationKeys = Object.keys(state).filter(key => key.startsWith(prefix) && VALIDATION_RESULT_SUFFIX.test(key.slice(prefix.length)));

  if (remaining.length === touched.length && validationKeys.length === 0) {
    return state;
  }

  const newState = {...state};

  newState[touchedKey] = remaining;
  validationKeys.forEach(key => delete newState[key]);

  return newState;
};
